<template>
  <v-container fluid>
    <v-row class="px-0 py-0 my-0">
      <v-col cols="3">
        <v-menu
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"
        :return-value.sync="date"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="date"
            label="Report date"
            prepend-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="date"
          no-title
          scrollable
        >
          <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            @click="menu = false"
          >
            Cancel
          </v-btn>
          <v-btn
            text
            color="primary"
            @click="$refs.menu.save(date)"
          >
            OK
          </v-btn>
        </v-date-picker>
      </v-menu>
        <v-text-field
            label="Select csv..."
            @click='onPickFile'
            v-model='fileName'
        ></v-text-field>
        <!-- Hidden -->
        <input
            type="file"
            style="display: none"
            ref="fileInput"
            accept="text/csv"
            @change="onFilePicked">
        <v-btn
            color="primary"
            @click.stop="onUploadSelectedFileClick"
            :loading="loading"
            :disabled="fileName == ''"
        >
          Import
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from '@/api/axios-auth'

export default {
  name: 'import-gai',
  data() {
    return {
      date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu: false,
      fileName: '',
      url: '',
      fileObject: null,
      cardResult: '',
      name: '',
      size: '',
      type: '',
      lastModifiedDate: '',
      loading: false
    }
  },
  mounted() {
  },
  computed: {},
  methods: {
    onPickFile() {
      this.$refs.fileInput.click()
    },
    onFilePicked(event) {
      const files = event.target.files
      if (files[0] !== undefined) {
        this.fileName = files[0].name

        if (this.fileName.lastIndexOf('.') <= 0) {
          return
        }

        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.url = fr.result
          this.fileObject = files[0]

        })
      } else {
        this.fileName = ''
        this.fileObject = null
        this.url = ''
      }
    },
    onUploadSelectedFileClick() {
      this.loading = true

      const formData = new FormData();
      formData.append('file', this.fileObject);
      formData.append('date', this.date);

      axios.post('/import/gai',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }).then(() => {
        this.loading = false;

        this.fileName = ''
        this.fileObject = null
        this.url = ''
        this.$refs.fileInput.value = null

      })
        .catch(() => {
          this.loading = false;

        });
    }
  }
}

</script>

<style scoped>
.chip::v-deep .v-chip {
  border-radius: 16px;
  font-size: 13px;
  height: 20px !important;
  color: white;
  background-color: #BDBDBD;
  margin: 4px 4px 0px 4px;
}
</style>
